import { render, staticRenderFns } from "./CardAnalyticRevenue.vue?vue&type=template&id=36afd4b1&"
import script from "./CardAnalyticRevenue.vue?vue&type=script&lang=js&"
export * from "./CardAnalyticRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports